import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag"; // or StorefrontIcon
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

const assets = {
    mainLogo: "/assets/logo/dover-logo-transparent.png",
    banners: {
        home: "/assets/banner/banner-home.png",
        about: "/assets/banner/banner-home.jpg",
        contact: "/assets/banner/banner-home.jpg",
    },
    icons: {
        menu: "/assets/icons/menu-icon.svg",
        cart: "/assets/icons/cart-icon.svg",
        phone: PhoneIcon,
        email: EmailIcon,
        location: LocationOnIcon,
        scheduleService: EventAvailableIcon,
        shop: ShoppingBagIcon,
        getQuote: RequestQuoteIcon,
        checkStatus: AssignmentTurnedInIcon,
    },
    images: {
        garageDoors: "/assets/images/garage-doors.jpg",
        entryDoors: "/assets/images/entry-doors.jpeg",
        patioDoors: "/assets/images/patio-doors.png",
        windows: "/assets/images/windows.jpg",
        gutters: "/assets/images/seamless-gutters.jpeg",
        vinylSiding: "/assets/images/vinyl-siding.jpg",
        openers: "/assets/images/openers-accessories.jpg",
        scheduleService: "/assets/images/schedule-service.jpg",
        
        sectionalDoors: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/commercial-sectional-doors.png",
        rollingSteelDoors: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/rolling-steel-doors.jpeg",
        loadingDocks: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/loading-docks.jpg",
        dockLevelers: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/dock-levelers.jpg",
        commercialOpeners: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/commercial-openers.jpg",
        hollowMetalDoors: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/hollow-metal-doors.png",
        bathroomPartitions: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/bathroom-partitions.png",
        commercialService: "https://doverdoors.nyc3.cdn.digitaloceanspaces.com/web-assets/homepage-icons/commercial-service.jpg",


    },
};

export default assets;
